import { Form } from 'react-bootstrap';

import './Campaign.css';

const Checkbox = ({
  className,
  handleChange,
  id,
  isSelected,
  labelName,
}: {
  className: string;
  handleChange: (cid: string) => void;
  id: string;
  isSelected: boolean;
  labelName: string;
}) => (
  <div className={`campaign__box ${className}`}>
    <Form.Check
      className="item-click d-flex align-items-center"
      name={id}
      id={id}
      custom
    >
      <Form.Check.Input
        type="checkbox"
        checked={isSelected}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleChange(e.target.id)
        }
        className="input-box"
      />
      <Form.Check.Label className="d-flex align-items-center">
        <span className="campaign__text">{labelName}</span>
      </Form.Check.Label>
    </Form.Check>
  </div>
);

export default Checkbox;
